export const ApiIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="30"
    height="30">
    <text
      x="10"
      y="40"
      fontSize="24"
      fontFamily="Arial, sans-serif"
      fill="black">
      API
    </text>
  </svg>
);
